import styles from './MeasurementCell.module.css';

import type { ReactNode } from 'react';

type MeasurementCellProps = {
  label: string;
  value: ReactNode;
};

/** Placeholder shown when a measurement value is null, undefined, or empty. */
const EMPTY_VALUE = '-';

/**
 * Small atom: a dimmed label stacked above a bold value. Repeated throughout
 * the freight measurement rows. Null/undefined/empty-string values render a
 * neutral `-` placeholder.
 */
export const MeasurementCell = ({ label, value }: MeasurementCellProps) => {
  const displayValue = value === null || value === undefined || value === '' ? EMPTY_VALUE : value;

  return (
    <div className={styles.cell} data-testid='measurement-cell'>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{displayValue}</span>
    </div>
  );
};
